import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class SimpleContentTypeParser implements Parser {
	parse(schema: Record<string, Schema.SimpleContentType>) {
		const names = Object.keys(schema).map((name) => `"${name}"`);

		return names.length
			? `export type SimpleContentTypes = ${names.join("|")}`
			: "";
	}
}
